import { UserCircleIcon } from '@heroicons/react/24/solid';

export const TopBarAccountButtonIcon = () => (
  <UserCircleIcon className="h-8 w-8 fill-current" />
);
